<template lang="pug">
div(
    :class="{ open: open }"
    :style="style"
    class="tl-expansion-panel"
)
    div(
        ref="panel"
    )
        slot
</template>

<script setup>
import { ref, computed, onMounted, watch, inject } from 'vue'
import { isClient } from '@vueuse/core'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    open: Boolean,
})

const injects = getInjects(props, inject)

const panel = ref(null)
const height = ref(0)
const setteled = ref(false)

const open = computed(() => props.open || injects.open?.value || false)

const controler = ref(open.value)

const updateHeight = () => {
    height.value = panel.value.getBoundingClientRect().height
}

onMounted(() => {
    if (isClient) {
        setteled.value = false
        updateHeight()
    }
})

let timer = null
watch(open, (val) => {
    if (isClient) {
        updateHeight()
        if (val) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                setteled.value = true
                clearTimeout(timer)
            }, 500)
            controler.value = true
        } else {
            clearTimeout(timer)
            setteled.value = false
            timer = setTimeout(() => {
                controler.value = false
                clearTimeout(timer)
            }, 10)
        }
    }
})

const style = computed(() => {
    let h = '0px'
    if (controler.value && setteled.value) {
        h = 'auto'
    } else if (controler.value && !setteled.value) {
        h = `${height.value}px`
    } else if (!controler.value && setteled.value) {
        h = `${height.value}px`
    } else {
        h = '0px'
    }
    return {
        height: h,
    }
})
</script>

<style lang="sass" scoped>
.tl-expansion-panel
    overflow: hidden !important
    transition: var(--transition-default)
    opacity: 0
    visibility: hidden
    &.open
        opacity: 1
        visibility: visible
</style>
